module.exports = __webpack_public_path__ + "static/media/xleg_mild_left.cc3ff9ee.png";